

























import { Actor, ActorTypes } from '@/data/models/actor.model';
import { Component, Vue } from 'vue-property-decorator';
import Attori from '../attori/Attori.vue';
import SelectAttore from '../attori/selectAttore/SelectAttore.vue';
import RinnovaTesseraModal from './RinnovaTesseraModal.vue';

@Component({
	components: {
		Attori,
		SelectAttore,
		RinnovaTesseraModal
	}
})
export default class VolontariList extends Vue{

	entity: string
	isComponentModalActive = false;
	isRenewCardModalActive = false;
	redirectOnNew: string;
	renewCardVolId!: number;

	constructor() {
		super();
		this.entity = ActorTypes.VOLUNTEER;
		this.redirectOnNew = '/attori/*/edit?tab=1';
	}

	onNewClicked() {
		this.isComponentModalActive = true;
	}

	onRenewCard(row: Actor) {
		if(row.volunteerid) {
			this.isRenewCardModalActive = true;
			this.renewCardVolId = row.volunteerid;
		}
	}

}
